module.exports = __webpack_public_path__ + "img/icon-FIRST.c0d48b4a.png";